import type { RoomStore } from '@fitness-force/models';

export const ROOM_STATE:RoomStore =   {
    rooms:[]
} 